import React, { useEffect, useState } from "react";
import "./Cta.scss";
import ctaimage from "../../assets/images/ctaimage.png";
import Button from "../Utils/Button";

import disbutton from "../../assets/images/disbutton.png";
import discord from "../../assets/images/discord.svg";
import { motion, useTransform, useViewportScroll } from "framer-motion";

function Cta() {
  const [delay, setdelay] = useState(0.58);
  useEffect(() => {
    if (window.innerWidth < 991) {
      setdelay(0);
    } else {
      setdelay(0.58);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 991) {
        setdelay(0);
      } else {
        setdelay(0.58);
      }
    });
  });
  const { scrollYProgress } = useViewportScroll();
  const scale = useTransform(scrollYProgress, [0, delay], [0.5, 1]);
  const opacity = useTransform(scrollYProgress, [0, delay], [0, 1]);
  return (
    <section className="cta">
      <div className="container">
        <motion.div
          className="row align-items-center"
          style={{ scale, opacity }}
        >
          <div className="col-12 col-md-6">
            <div className="cta-text upheav">
              Build the gaming Metaverse, from India, for the world
            </div>

            <Button text={"Join our Discord"} image={discord} />
          </div>

          <div className="col-12 col-md-6 text-center cta-image">
            <img src={ctaimage} alt="" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default Cta;
